import { compose, withProps } from 'recompose';
import { Redirect } from 'react-router-dom';

import withLocale from 'app/features/localization/enhancers/withLocale';
import localizeLink from 'app/features/localization/localizeLink';
import withAppName from 'app/enhancers/withAppName';
import { ALREADY_PREMIUM_PATH } from 'app/router/constants/paths';
import connect from 'app/libs/connect';
import { getSearch } from 'app/router/selectors';

const to = ({ locale, appName, search }) => ({
  to: localizeLink(`/${appName}${ALREADY_PREMIUM_PATH}${search}`, locale),
});

const AlreadyPremiumRedirect = compose(
  connect({ search: getSearch }),
  withLocale,
  withAppName,
  withProps(to),
)(Redirect);

export { to };

export default AlreadyPremiumRedirect;
